export { getItem, setItem, removeItem, clearSessionStorage } from './sessionStorageAdapter';
